import { h } from './utils/dom.ts';
import { t } from './i18n/index.ts';

/** Registers /sw.js in production builds and offers a reload when an update is waiting. */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');
      reg.addEventListener('updatefound', () => {
        const worker = reg.installing;
        worker?.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) showUpdateBanner(worker);
        });
      });
    } catch (err) {
      console.warn('Service worker registration failed', err);
    }
  });
}

function showUpdateBanner(worker: ServiceWorker): void {
  const banner = h('div', { class: 'update-banner', role: 'status' },
    h('span', null, t('app.update')),
    h('button', {
      type: 'button',
      class: 'btn btn-primary btn-sm',
      onClick: () => {
        navigator.serviceWorker.addEventListener('controllerchange', () => location.reload(), { once: true });
        worker.postMessage('SKIP_WAITING');
      },
    }, t('app.reload')),
  );
  document.body.append(banner);
}
